// src/pages/apps/chat/Chat.tsx
import ChatProvider from 'providers/ChatProvider';
import { Outlet } from 'react-router-dom';

const Chat = () => {
  return (
    /* Quitamos conversations={conversations} porque el Provider 
       ahora busca la data en tu base de datos automáticamente */
    <ChatProvider>
      <div className="chat d-flex gap-3">
        <Outlet />
      </div>
    </ChatProvider>
  );
};

export default Chat;